export default "__VITE_ASSET__A7G2hfGz__"